import { useSyncExternalStore } from "react";

let count = 0;
const listeners = new Set<() => void>();
const notify = () => listeners.forEach((l) => l());

export function enterImmersive(): void {
  count += 1;
  notify();
}
export function exitImmersive(): void {
  count = Math.max(0, count - 1);
  notify();
}

export function useImmersive(): boolean {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => count > 0,
    () => count > 0,
  );
}
